import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
// remove the first occurence of needle in haystack
export var removeOne = function removeOne(haystack, needle) {
  var position = -1;
  if (typeof needle === 'string') {
    position = haystack.indexOf(needle);
  } else {
    var label = needle.label;
    for (var i = 0; i < haystack.length; i += 1) {
      if (haystack[i].label === label) {
        position = i;
        break;
      }
    }
  }
  if (position !== -1) {
    var temp = _toConsumableArray(haystack);
    temp.splice(position, 1);
    return temp;
  }
  return haystack;
};

// append to an array
export var appendOne = function appendOne(haystack, needle) {
  return haystack.concat(needle);
};

// check if an array contains a failure
export var matches = function matches(haystack, needle) {
  var match = haystack.filter(function (item) {
    return item.label === needle.label;
  })[0];
  if (match && needle.status) {
    return match.status === needle.status;
  }
  return !!match;
};